import { lazy } from 'react';

const ReportModal = lazy(() => import('./modals/ReportModal'));
const EditReportModal = lazy(() => import('./modals/ReportModal/EditModal'));

export default {
  'RC/REPORT_GENERATION_MODAL': ReportModal,
  'RC/REPORT_EDIT_MODAL': EditReportModal,
};
